var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { title: "添加/编辑客户", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "归属公司：", prop: "companyId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请输入选择",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.searchLoading,
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.companyId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "companyId", $$v)
                        },
                        expression: "form.companyId",
                      },
                    },
                    _vm._l(_vm.searchOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.id,
                        attrs: { label: opt.name, value: opt.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登录账号：", prop: "loginAccount" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.loginAccount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "loginAccount", $$v)
                      },
                      expression: "form.loginAccount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登录密码：", prop: "loginPassword" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.loginPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "loginPassword", $$v)
                      },
                      expression: "form.loginPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "授信金额：", prop: "creditAmount" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.creditAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "creditAmount", $$v)
                      },
                      expression: "form.creditAmount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合作状态：", prop: "cooperationStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请输入选择" },
                      model: {
                        value: _vm.form.cooperationStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cooperationStatus", $$v)
                        },
                        expression: "form.cooperationStatus",
                      },
                    },
                    _vm._l(_vm.cooperationStatusEnum, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "运营方式：", prop: "ljcType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请输入选择" },
                      model: {
                        value: _vm.form.ljcType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ljcType", $$v)
                        },
                        expression: "form.ljcType",
                      },
                    },
                    _vm._l(_vm.platformTypeEnum, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "票务类型：", prop: "ticketType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.ticketType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ticketType", $$v)
                        },
                        expression: "form.ticketType",
                      },
                    },
                    _vm._l(_vm.ticketTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "结算方式：", prop: "settlementMethod" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.settlementMethod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "settlementMethod", $$v)
                        },
                        expression: "form.settlementMethod",
                      },
                    },
                    _vm._l(_vm.settlementMethodEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "对接人：", prop: "contactPerson" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.contactPerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contactPerson", $$v)
                      },
                      expression: "form.contactPerson",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "对接人职位：", prop: "contactPosition" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.contactPosition,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contactPosition", $$v)
                      },
                      expression: "form.contactPosition",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "对接人电话：", prop: "contactPhone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.form.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contactPhone", $$v)
                      },
                      expression: "form.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "维护人", prop: "maintainerId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择维护人",
                        filterable: "",
                        "filter-method": _vm.handleUserSearch,
                      },
                      model: {
                        value: _vm.form.maintainerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "maintainerId", $$v)
                        },
                        expression: "form.maintainerId",
                      },
                    },
                    _vm._l(_vm.userOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label:
                            "" +
                            item.realName +
                            (item.flag == 1 ? "（当前登陆人）" : ""),
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }